import { useMemo, useSyncExternalStore } from 'react';
import { useAuth } from '../../App';
import { browserStorage, recoveryPrefix, commandBody } from '../../../../packages/shared/browser-recovery/storage';
import { savedCommands } from '../../../../packages/shared/browser-recovery/commands';
import { countRequest, CountHttpError } from '../../../../packages/shared/stock-count/client';
type Command = { requestId: string; path: string; body: string };
export function useTransferCommands() {
  const { user, currentShop, currentOrganization } = useAuth();
  const userId = String(user?.id || ''), domain = currentShop?.domain || '', organizationId = currentOrganization?.id || '';
  const commands = useMemo(() => {
    const base = import.meta.env.VITE_API_URL || 'https://api.whenlyapp.com';
    const account = { userId, domain, organizationId };
    return savedCommands<Command, { success: boolean; request_id: string; transferred: number }>({
      storage: browserStorage, prefix: recoveryPrefix('inventory-transfer',base,account),
      validate: (value: unknown): asserts value is Command => { commandBody(value,userId); if ((value as Command).path !== '/transfer') throw new Error('Invalid saved transfer'); },
      definitive: error => error instanceof CountHttpError && [400,404,409,422].includes(error.status),
      send: async command => {
        const result = await countRequest<{success:boolean;request_id:string;transferred:number}>(base,account,command.path,{method:'POST',body:command.body});
        if (result.success !== true || result.request_id !== command.requestId || result.transferred !== (Array.isArray(JSON.parse(command.body).items) ? JSON.parse(command.body).items.length : 1)) throw new Error('The saved transfer could not be confirmed. Retry the saved action.');
        return result;
      },
    });
  },[userId,domain,organizationId]);
  const state = useSyncExternalStore(commands.subscribe,commands.snapshot,commands.snapshot);
  return { ...commands, state, async transfer(body: Record<string,unknown>) {
    const requestId=crypto.randomUUID();
    await commands.submit({requestId,path:'/transfer',body:JSON.stringify({...body,request_id:requestId,expected_user_id:userId})});
    return commands.snapshot().success;
  }};
}
